var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M21,0H3A1,1,0,0,0,2,1V23a1,1,0,0,0,2,0V22H20v1a1,1,0,0,0,2,0V1A1,1,0,0,0,21,0ZM20,2v8H4V2ZM4,20V12H20v8Z","fill":"#000000"}}),_c('path',{attrs:{"d":"M11,4H7A1,1,0,0,0,6,5V8h6V5A1,1,0,0,0,11,4Z"}}),_c('path',{attrs:{"d":"M17,14H13a1,1,0,0,0-1,1v3h6V15A1,1,0,0,0,17,14Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }